import {
  Topic, Topics,
  FetchTopicsAction, FETCH_TOPICS, FetchTopicsSucceededAction, FETCH_TOPICS_SUCCEEDED, FetchTopicsFailedAction, FETCH_TOPICS_FAILED,
  CreateTopicAction, CREATE_TOPIC, CreateTopicSucceededAction, CREATE_TOPIC_SUCCEEDED, CreateTopicFailedAction, CREATE_TOPIC_FAILED,
  UpdateTopicAction, UPDATE_TOPIC, UpdateTopicSucceededAction, UPDATE_TOPIC_SUCCEEDED, UpdateTopicFailedAction, UPDATE_TOPIC_FAILED,
  DeleteTopicAction, DELETE_TOPIC, DeleteTopicSucceededAction, DELETE_TOPIC_SUCCEEDED, DeleteTopicFailedAction, DELETE_TOPIC_FAILED,
  FetchSynonymsAction, FETCH_SYNONYMS, FetchSynonymsSucceededAction, FETCH_SYNONYMS_SUCCEEDED, FetchSynonymsFailedAction, FETCH_SYNONYMS_FAILED,
  FetchAntonymsAction, FETCH_ANTONYMS, FetchAntonymsSucceededAction, FETCH_ANTONYMS_SUCCEEDED, FetchAntonymsFailedAction, FETCH_ANTONYMS_FAILED,
  PollSyncStatusAction, POLL_SYNCSTATUS,
  PollSyncStatusSucceededAction, POLL_SYNCSTATUS_SUCCEEDED,
  PollSyncStatusFailedAction, POLL_SYNCSTATUS_FAILED,
  TopicSyncState,
  SyncTopicsAction, SYNC_TOPICS, SyncTopicsSucceededAction, SYNC_TOPICS_SUCCEEDED, SyncTopicsFailedAction, SYNC_TOPICS_FAILED, TopicSyncRequestState,
  CreateSynonymAction, CREATE_SYNONYM, CreateSynonymSucceededAction, CREATE_SYNONYM_SUCCEEDED, CreateSynonymFailedAction, CREATE_SYNONYM_FAILED,
  CreateAntonymAction, CREATE_ANTONYM, CreateAntonymSucceededAction, CREATE_ANTONYM_SUCCEEDED, CreateAntonymFailedAction, CREATE_ANTONYM_FAILED,
} from './types';

export const FetchTopics = () : FetchTopicsAction => ({
  type: FETCH_TOPICS,
});

export const FetchTopicsSucceeded = (topics: Topics): FetchTopicsSucceededAction => ({
  type: FETCH_TOPICS_SUCCEEDED,
  topics,
});

export const FetchTopicsFailed = (errorMessage: string): FetchTopicsFailedAction => ({
  type: FETCH_TOPICS_FAILED,
  errorMessage,
});

export const CreateTopic = (topic: Topic) : CreateTopicAction => ({
  type: CREATE_TOPIC,
  topic,
});

export const CreateTopicSucceeded = (topic: Topic) : CreateTopicSucceededAction => ({
  type: CREATE_TOPIC_SUCCEEDED,
  topic,
});

export const CreateTopicFailed = (errorMessage: string) : CreateTopicFailedAction => ({
  type: CREATE_TOPIC_FAILED,
  errorMessage,
});

export const UpdateTopic = (topic: Topic) : UpdateTopicAction => ({
  type: UPDATE_TOPIC,
  topic,
});

export const UpdateTopicSucceeded = (topic: Topic) : UpdateTopicSucceededAction => ({
  type: UPDATE_TOPIC_SUCCEEDED,
  topic,
});

export const UpdateTopicFailed = (errorMessage: string) : UpdateTopicFailedAction => ({
  type: UPDATE_TOPIC_FAILED,
  errorMessage,
});

export const DeleteTopic = (topic: Topic) : DeleteTopicAction => ({
  type: DELETE_TOPIC,
  topic,
});

export const DeleteTopicSucceeded = (topicId: number) : DeleteTopicSucceededAction => ({
  type: DELETE_TOPIC_SUCCEEDED,
  topicId,
});

export const DeleteTopicFailed = (errorMessage: string) : DeleteTopicFailedAction => ({
  type: DELETE_TOPIC_FAILED,
  errorMessage,
});

export const FetchSynonyms = () : FetchSynonymsAction => ({
  type: FETCH_SYNONYMS,
});

export const FetchSynonymsSucceeded = (synonyms: string[]): FetchSynonymsSucceededAction => ({
  type: FETCH_SYNONYMS_SUCCEEDED,
  synonyms,
});

export const FetchSynonymsFailed = (errorMessage: string): FetchSynonymsFailedAction => ({
  type: FETCH_SYNONYMS_FAILED,
  errorMessage,
});

export const FetchAntonyms = () : FetchAntonymsAction => ({
  type: FETCH_ANTONYMS,
});

export const FetchAntonymsSucceeded = (antonyms: string[]): FetchAntonymsSucceededAction => ({
  type: FETCH_ANTONYMS_SUCCEEDED,
  antonyms,
});

export const FetchAntonymsFailed = (errorMessage: string): FetchAntonymsFailedAction => ({
  type: FETCH_ANTONYMS_FAILED,
  errorMessage,
});

export const PollSyncStatus = () : PollSyncStatusAction => ({
  type: POLL_SYNCSTATUS,
});

export const PollSyncStatusSucceeded = (syncState: TopicSyncState): PollSyncStatusSucceededAction => ({
  type: POLL_SYNCSTATUS_SUCCEEDED,
  syncState,
});

export const PollSyncStatusFailed = (errorMessage: string): PollSyncStatusFailedAction => ({
  type: POLL_SYNCSTATUS_FAILED,
  errorMessage,
});

export const SyncTopics = () : SyncTopicsAction => ({
  type: SYNC_TOPICS,
});

export const SyncTopicsSucceeded = (requestState: TopicSyncRequestState): SyncTopicsSucceededAction => ({
  type: SYNC_TOPICS_SUCCEEDED,
  requestState,
});

export const SyncTopicsFailed = (errorMessage: string): SyncTopicsFailedAction => ({
  type: SYNC_TOPICS_FAILED,
  errorMessage,
});

export const CreateSynonym = (synonym: string) : CreateSynonymAction => ({
  type: CREATE_SYNONYM,
  synonym,
});

export const CreateSynonymSucceeded = (synonym: string) : CreateSynonymSucceededAction => ({
  type: CREATE_SYNONYM_SUCCEEDED,
  synonym,
});

export const CreateSynonymFailed = (errorMessage: string) : CreateSynonymFailedAction => ({
  type: CREATE_SYNONYM_FAILED,
  errorMessage,
});

export const CreateAntonym = (antonym: string) : CreateAntonymAction => ({
  type: CREATE_ANTONYM,
  antonym,
});

export const CreateAntonymSucceeded = (antonym: string) : CreateAntonymSucceededAction => ({
  type: CREATE_ANTONYM_SUCCEEDED,
  antonym,
});

export const CreateAntonymFailed = (errorMessage: string) : CreateAntonymFailedAction => ({
  type: CREATE_ANTONYM_FAILED,
  errorMessage,
});
